import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import type { ComponentOrientation } from '@/types';
import Button, { type ButtonProps, type ButtonTone } from '@/components/Button';
import DialogActions from '../DialogActions';
import { classes } from './utils';

export type DefaultDialogActionsProps = {
  disabled?: boolean;
  pending?: boolean;
  destructive?: boolean;
  fullWidth?: boolean;
  className?: string;
  orientation?: ComponentOrientation;
  tone?: ButtonTone;
  confirmLabel?: string;
  pendingLabel?: string;
  cancelLabel?: string;
  confirmIcon?: ReactNode;
  adornment?: ReactNode;
  onConfirm: ButtonProps['onClick'];
  onCancel?: () => void;
};

export default function DefaultDialogActions({
  disabled,
  pending,
  destructive = false,
  fullWidth = false,
  className,
  orientation = 'horizontal',
  tone = 'brand',
  confirmLabel = 'Confirm',
  pendingLabel = 'Saving',
  cancelLabel = 'Cancel',
  confirmIcon,
  adornment,
  onConfirm,
  onCancel,
}: DefaultDialogActionsProps) {
  const getRowClass = () => {
    if (!fullWidth) return undefined;
    if (orientation === 'vertical') return classes.fullWidthVertical;
    return onCancel ? classes.fullWidthDual : classes.fullWidthSingle;
  };
  const fill = fullWidth ? classes.fill : undefined;
  return (
    <DialogActions className={twMerge(getRowClass(), className)}>
      {onCancel && (
        <Button
          disabled={pending}
          className={fill}
          variant="secondary"
          onClick={onCancel}>
          {cancelLabel}
        </Button>
      )}
      <div className={twMerge(classes.confirmWrapper, fill)}>
        {adornment}
        <Button
          disabled={disabled}
          loading={pending}
          className={fill}
          variant="primary"
          tone={destructive ? 'danger' : tone}
          icon={confirmIcon}
          onClick={onConfirm}>
          {pending ? pendingLabel : confirmLabel}
        </Button>
      </div>
    </DialogActions>
  );
}
